import { alpha, border, padding } from "@mui/system";

const styles = (theme) => ({
  containerModal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "16px",
    width: "100%",
    height: "100vh",
    overflow: "hidden",
  },
  linearProgres: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
  },
  containerButton: {
    display: "flex",
    gap: 1,
    justifyContent: "flex-end",
    marginTop: 2,
  },
  conatinerLoading: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  boxTextField: { position: "relative", width: "100%" },
  BoxExitModal: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "50px",
    height: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  paperItens: {
    height: "79%",
    p: 2,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    borderRadius: "16px",
    gap: 1,
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.colors.black.dark, 0.4)
        : theme.palette.colors.black.lighter,
  },
});

export default styles;
